import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {CountryCode} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class CountryCodeService {

    url = '/api/v1/country';
    private countryCodes: CountryCode[];
    private countryCodesSubject = new Subject<CountryCode[]>();

    constructor(public http: HttpClient) {
    }

    isValidCountryCode(code) {
        code = parseInt(code, 10);
        const found = this.countryCodes.find(cc => cc.phone_code === code);
        return !!found;
    }

    getAllCountryCodes(): Observable<CountryCode[]> {
        this.http.get<CountryCode[]>(this.url).subscribe(data => {
            this.countryCodes = data;
            this.countryCodesSubject.next(data);
        });

        return this.countryCodesSubject.asObservable();
    }

    updateCountryCodes(countyCodes: CountryCode[]): Observable<CountryCode[]> {
        this.http.put<CountryCode[]>(this.url, countyCodes).subscribe(data => {
            this.countryCodesSubject.next(data);
        });

        return this.countryCodesSubject.asObservable();
    }
}
